import * as bootstrap from 'bootstrap'


// Página
let tam_navbar = document.getElementById('nav_bar').clientHeight;


let paginas = document.getElementsByClassName('pagina-g');
Array.from(paginas).forEach(pagina => pagina.style.minHeight= `calc(100vh - ${tam_navbar}px)`);

// nav-video
const nav_videos = document.getElementsByClassName('nav-video');
const nav_tabs = document.getElementsByClassName('tab-pane');
let nav_tab_act = nav_tabs[0];
Array.from(nav_tabs).forEach(nav_tab => {
  if(nav_tab.classList.contains('active')){
    nav_tab_act = nav_tab;
  }
});
if(nav_tab_act.querySelector('.nav-video') != null){
Array.from(nav_videos).forEach(nav_video => nav_video.style.height= `calc(
${nav_tab_act.querySelector('.nav-video').getBoundingClientRect().width/1.6}px)`);
}
//scroll
const nav_tab_panel = document.getElementById('nav-tab')
let nav_tab_posT = nav_tab_panel.offsetTop;
let nav_tab_posB = nav_tab_posT - window.innerHeight;


nav_tab_panel.addEventListener('shown.bs.tab', () => {

  let scroll_pos = window.scrollY;
  Array.from(nav_tabs).forEach(nav_tab => {
    if(nav_tab.classList.contains('active')){
      nav_tab_act = nav_tab;
    }
  });

  if(nav_tab_act.querySelector('.nav-video') != null){
    if (scroll_pos >= nav_tab_posB && scroll_pos <= nav_tab_posT){

      nav_tab_act.querySelector('.nav-video').play()

    }
  }
})

let loader_1video = 1;
window.addEventListener('scroll', () =>{

  if(loader_1video == 1){

    let scroll_pos = window.scrollY;

    if (scroll_pos >= nav_tab_posB && scroll_pos <= nav_tab_posT){

     document.querySelector('#logo-video').play()
     loader_1video++;
    }

  

  }
  


})

// nav-bar links

const links = document.querySelectorAll('#navbarSupportedContent a');
const botones = document.querySelectorAll('#but-ini a');
function pos_window (id){

  return document.getElementById(id).offsetTop;

}
links[0].addEventListener('click',() => {window.scrollTo(0,pos_window('bienvenida') - 16)})
links[1].addEventListener('click',() => {window.scrollTo(0,pos_window('servicios') - 16)})
links[2].addEventListener('click',() => {window.scrollTo(0,pos_window('contact') - 16)})
botones[0].addEventListener('click',() => {window.scrollTo(0,pos_window('contact') - 16)})
botones[1].addEventListener('click',() => {window.scrollTo(0,pos_window('servicios') - 16)})
/* Fireflies */
let c = init("canvas");
var w = canvas.width = document.getElementById("inicio").clientWidth;
var h = canvas.height = document.getElementById("inicio").clientHeight;
var pos_left = document.getElementById('inicio').getBoundingClientRect().left + document.documentElement.scrollLeft;
var pos_top = document.getElementById('inicio').getBoundingClientRect().top + document.documentElement.scrollTop;
document.getElementById('canvas').style.left = String(pos_left) + 'px';
document.getElementById('canvas').style.top = String(pos_top) + 'px';

// initiation

class firefly {
  constructor() {
    this.x = Math.random() * w;
    this.y = Math.random() * h;
    this.s = Math.random() * 2;
    this.ang = Math.random() * 2 * Math.PI;
    this.v = (this.s * this.s) / 4;
  }
  move() {
    this.x += this.v * Math.cos(this.ang);
    this.y += this.v * Math.sin(this.ang);
    this.and += (Math.random() * 20 * Math.PI) / 180 - (10 * Math.PI) / 180;
  }
  show() {
    c.beginPath();
    c.arc(this.x, this.y, this.s, 0, 2 * Math.PI);
    c.fillStyle = "#fddba3";
    c.fill();
  }
}
let f = [];

function draw() {
  if (f.length < 100) {
    for (let j = 0; j < 10; j++) {
      f.push(new firefly());
    }
  }
  //animation
  for (let i = 0; i < f.length; i++) {
    f[i].move();
    f[i].show();
    if (f[i].x < 0 || f[i].x > w || f[i].y < 0 || f[i].y > h) {
      f.splice(i, 1);
    }
  }
}

let mouse = {};
let last_mouse = {};

canvas.addEventListener(
  "mouseover",
  function (e) {
    last_mouse.x = mouse.x;
    last_mouse.y = mouse.y;

    mouse.x = e.pageX - this.offsetLeft;
    mouse.y = e.pageY - this.offsetTop;
  },
  false
);

function init(elemid) {
  let canvas = document.getElementById(elemid),
    c = canvas.getContext("2d"),
    w = (canvas.width = document.getElementById("inicio").clientWidth),
    h = (canvas.height = document.getElementById("inicio").clientHeight);
  c.fillStyle = "rgba(30, 30, 30, 1)";
  c.fillRect(0, 0, w, h);
  return c;
}
window.requestAnimationFrame = function () {
  return (
    window.requestAnimationFrame ||
    function (callback) {
      window.setTimeout(callback);
    }
  );
};

function loop() {
  window.requestAnimationFrame(loop);
  c.clearRect(0, 0, w, h);
  draw();
}
window.addEventListener("resize", function () {

  var tam_navbar = document.getElementById('nav_bar').clientHeight;
  var paginas = document.getElementsByClassName('pagina-g');
  Array.from(paginas).forEach(pagina => pagina.style.minHeight = `calc(100vh - ${tam_navbar}px)`);
  var pos_left = document.getElementById('inicio').getBoundingClientRect().left + document.documentElement.scrollLeft;
  var pos_top = document.getElementById('inicio').getBoundingClientRect().top + +document.documentElement.scrollTop;
  document.getElementById('canvas').style.left = String(pos_left) + 'px';
  document.getElementById('canvas').style.top = String(pos_top) + 'px';

  Array.from(nav_tabs).forEach(nav_tab => {
    if(nav_tab.classList.contains('active')){
      nav_tab_act = nav_tab;
    }
  });
  if(nav_tab_act.querySelector('.nav-video') != null){
  Array.from(nav_videos).forEach(nav_video => nav_video.style.height= `calc(
    ${nav_tab_act.querySelector('.nav-video').getBoundingClientRect().width/1.6}px)`);
  
  }



  (w = canvas.width = document.getElementById("inicio").clientWidth),
  (h = canvas.height = document.getElementById("inicio").clientHeight);
  loop();
});

function resize_canvas() {


  var pos_top1 = document.getElementById('inicio').getBoundingClientRect().top +
    document.documentElement.scrollTop;

  document.getElementById('canvas').style.top = pos_top1.toString() + 'px';

}



var myCollapsible = document.getElementById('btn_toggle')

myCollapsible.addEventListener('click', () => {

  var  myInterval = setInterval(resize_canvas, 10)

    setTimeout(() => {
      clearInterval(myInterval)
    }, 1200)
  }

);

loop();
setInterval(loop, 1000 / 60);


/*  Particles  */
particlesJS("canvas-bienvenida", {
  "particles": {
    "number": {
      "value": 128,
      "density": {
        "enable": true,
        "value_area": 1893.9842325812622
      }
    },
    "color": {
      "value": "#ffffff"
    },
    "shape": {
      "type": "circle",
      "stroke": {
        "width": 0,
        "color": "#000000"
      },
      "polygon": {
        "nb_sides": 5
      },
    },
    "opacity": {
      "value": 0.5,
      "random": false,
      "anim": {
        "enable": false,
        "speed": 1,
        "opacity_min": 0.1,
        "sync": false
      }
    },
    "size": {
      "value": 2,
      "random": true,
      "anim": {
        "enable": true,
        "speed": 3,
        "size_min": 0.09,
        "sync": false
      }
    },
    "line_linked": {
      "enable": false,
      "distance": 150,
      "color": "#ffffff",
      "opacity": 0.4,
      "width": 1
    },
    "move": {
      "enable": true,
      "speed": 1,
      "direction": "none",
      "random": true,
      "straight": false,
      "out_mode": "out",
      "bounce": false,
      "attract": {
        "enable": false,
        "rotateX": 600,
        "rotateY": 1200
      }
    }
  },
  "interactivity": {
    "detect_on": "canvas",
    "events": {
      "onhover": {
        "enable": false,
        "mode": "bubble"
      },
      "onclick": {
        "enable": true,
        "mode": "push"
      },
      "resize": true
    },
    "modes": {
      "grab": {
        "distance": 400,
        "line_linked": {
          "opacity": 1
        }
      },
      "bubble": {
        "distance": 400,
        "size": 40,
        "duration": 2,
        "opacity": 8,
        "speed": 3
      },
      "repulse": {
        "distance": 200,
        "duration": 0.4
      },
      "push": {
        "particles_nb": 4
      },
      "remove": {
        "particles_nb": 2
      }
    }
  },
  "retina_detect": true
});
/* Texto animado*/
//Convertir cada letra en span
const texto = document.querySelector(".texto-anim");
const strtexto = texto.textContent;
const spltexto = strtexto.split("");
texto.textContent = "" ;
for(let i=0; i<spltexto.length; i++){

  if (spltexto[i] == '&'){texto.innerHTML += "<br/>"}
  else{texto.innerHTML += "<span class=\"letra\">"+spltexto[i]+"</span>";}

}
//--------------------------------------------------------

document.getElementById('nav-design-tab').addEventListener('click',()=>{

let char = 0;
let timer = setInterval(onTick, 50);

function onTick(){
    const span = texto.querySelectorAll(".letra")[char];
    span.classList.add("fade");
    char++
    if(char == document.getElementsByClassName('letra').length){
        complete();
        return;
    }
}

function complete(){
    clearInterval(timer);
    timer = null;
}

})


